import React, { Suspense, lazy, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,

} from "react-router-dom";
import { Outlet } from 'react-router-dom';
import { RXNavbar } from "./components/RxNavbar";
import { RxSiteViewHandler } from "./site/RxSiteViewHandler";
import { CartProvider } from "./components/CartProvider";
import { MessageDisplay } from "@shared_components/providers/MessageProvider";

function RXApp() {

  return (
    <Router>
      <Routes>
        {/* navbar paths */}

        <Route element={<MainLayout />} >
          <Route path="/" element={<RxSiteViewHandler />} />
        </Route>

        <Route path="*" element={<div> <p>Page test not found</p></div>} />
      </Routes>
    </Router>
  );
}

export default RXApp;



const MainLayout = () => {
  return (
    <CartProvider>
      <RXNavbar />
      <main> {/* Optional: wrap the page content */}
        <Outlet /> {/* Child route components will be rendered here */}
        <MessageDisplay />
      </main>
    </CartProvider>
  );
};

